// src/components/SongFilter.js
import React, { useState, useEffect } from 'react';
import translations from '../utils/translations';

export default function SongFilter({
  categories = [],
  onFilterChange,
  currentLanguage,
  initialActive = '',
  categoryHints = {},
  // Pestaña “Seleccionados” (icono)
  selectedActive = false,
  onSelectSelected = () => {},
}) {
  // Estado local solo para las categorías normales
  const [active, setActive] = useState(
    initialActive === 'Seleccionados' ? '' : (initialActive || '')
  );
  const tCats = translations[currentLanguage]?.categories || {};

  // Mantener sincronizado si cambia desde arriba
  useEffect(() => {
    setActive(initialActive === 'Seleccionados' ? '' : (initialActive || ''));
  }, [initialActive, currentLanguage]);

  const handleClick = (cat) => {
    setActive(cat);
    if (typeof onFilterChange === 'function') onFilterChange(cat);
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* Botón “Seleccionados” con el mismo icono que en las cartas */}
      <button
        onClick={onSelectSelected}
        className={
          'flex items-center justify-center w-9 h-9 rounded-full border shadow-sm transition ' +
          (selectedActive
            ? 'bg-yellow-400 text-yellow-900 ring-2 ring-yellow-500'
            : 'bg-white text-gray-700 hover:bg-gray-100')
        }
        title={selectedActive ? 'Ver seleccionados (activo)' : 'Ver solo seleccionados'}
        aria-pressed={selectedActive}
      >
        {/* Icono check */}
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
      </button>

      {/* Pestañas de categorías */}
      {categories.map((cat) => {
        const count = categoryHints[cat] || 0;
        const hasSongs = count > 0;
        const isActive = active === cat;

        // Estilos base
        const base = 'relative px-3 py-1 rounded-full border transition shadow-sm';
        const activeCls = 'bg-black text-white border-black';
        const normalCls = 'bg-white text-gray-700 hover:bg-gray-100';

        // 🔆 NUEVO: sombreado suave cuando hay cantos (sin aro ni puntito)
        // Solo aplicamos el sombreado cuando NO está activa la pestaña
        const shadedHint = hasSongs && !isActive ? ' bg-amber-50 border-amber-400 shadow-inner' : '';

        return (
          <button
            key={cat}
            onClick={() => handleClick(cat)}
            className={`${base} ${isActive ? activeCls : normalCls}${shadedHint}`}
            title={
              hasSongs
                ? 'Hay cantos en los idiomas seleccionados'
                : 'Sin cantos en los idiomas seleccionados'
            }
          >
            {tCats[cat] || cat}
            {count > 0 && (
              <span className="ml-1 text-xs font-semibold text-amber-700">({count})</span>
            )}
            {/* Eliminado: puntito/halo; ahora solo sombreado */}
          </button>
        );
      })}
    </div>
  );
}
